// extracted by mini-css-extract-plugin
export default {"cls1":"jRpPk45kkbPIURsqzfBM","cls2":"E8hhFWpFGXYxpxmnaewZ jRpPk45kkbPIURsqzfBM","isPhone":"OLOjlKwMiNxxLSNWkFwx","bookingAppRedesign":"CniXQrFnUv0vybFxrOSy"};